/**
 * Blank model for the New Work Order form; defaults to a conf call with claimant confirmation on.
 */
export function NewWorkOrderModel() {
  return {
    EventType: "insert",
    JobNum: 0,
    JobId: null,
    JobDateTime: null,
    JobTime: null,
    FinishTime: null,
    FinishTimeString: null,
    FollowupDate: null,
    ProvId: null,
    ProviderName: "",
    ConfCallNote: "",
    AptName: "",
    AptStreet: "",
    AptCity: "",
    AptState: "",
    AptZip: "",
    AptPhone: "",
    AptDirection: "",
    FailedFlg: false,
    CallerNote: "",
    InvoiceNote: "",
    IntCheckDate: null,
    IntCheckNum: null,
    InvoicedFlg: false,
    IntFinalConfEmailSentFlg: false,
    JobTotal: null,
    JobDiscount: null,
    IntFee: null,
    IntFeeOther: null,
    IntOTFee: null,
    IntFeeNote: "",
    TransportationFlg: false,
    TransConfFlg: false,
    IntConfFlg: false,
    AppointmentTypeId: "9e5e4810-c5a8-428b-8f7d-71422b6b77e3", // conf call
    CallerType: null,
    ProvConfFlg: false,
    ClmConfFlg: true,
    IsDeletedFlg: false,
    BillReviewedFlg: false,
    AuditFlg: false,
    PurpleReportFlg: false,
    RepAuthorizedFlg: false,
    SelectedFlg: false,
    ClmId: "",
    ClmFirstName: "",
    ClmLastName: "",
    ClmClaimNumber: "",
    ClmClaimNumberNoDash: "",
    ClmPhone: "",
    ClmDateOfLoss: "",
    ClmDateOfInjury: "",
    ClmDateOfInjuryStart: null,
    ClmDateOfInjuryEnd: null,
    ClmDateOfLossDate: null,
    ClmNote: "",
    ClmDOB: null,
    ClmInsuredParty: "",
    ClmEmployer: "",
    ClmInvoiceCaption: "",
    ClmLanguage: "",
    ClmWCABNumber: "",
    ClmInvoiceType: "",
    ClmStreet: "",
    ClmCity: "",
    ClmState: "",
    ClmZip: "",
    ClmSSN: "",
    ClmOrderedByName: "",
    ClmDiagnosis: "",
    ClmEmail: "",
    ClmHasAttorneyFlg: false,
    RepId: null,
    RepFirstName: "",
    RepLastName: "",
    RepPhone: "",
    RepEmail: "",
    ClientId: "",
    ClientAbbrv: "",
    ClientName: "",
    ClientStreet: "",
    ClientStreet2: "",
    ClientCity: "",
    ClientState: "",
    ClientZip: "",
    ClientMailStreet: "",
    ClientMailStreet2: "",
    ClientMailCity: "",
    ClientMailState: "",
    ClientMailZip: "",
    ClientPhone: "",
    ClientPhoneFax: "",
    ClientPhone2: "",
    ClientEmail: "",
    ClientInactiveFlg: false,
    IntId: null,
    IntLastName: "",
    IntFirstName: "",
    IntCellTxt: "",
    IntPhoneOnly: "",
    IntEmail: "",
    IntNote: "",
    InHouseFlg: false,
    IntCity: "",
    IntStreet: "",
    IntState: "",
    IntZip: "",
    DBA: "",
    Rate: 0,
    HourMinimum: 0,
    Prorate: "",
    BankRoute: "",
    BankAccount: "",
    IntSSINumber: "",
    FirstName: "",
    LastName: "",
    UserType: "",
    UserIntId: null,
    CreateDateTime: null,
    CreateByUserId: null,
    RemIntFlg: false,
    RemClaimFlg: false,
    RemProvFlg: false,
    RemFinalFlg: false,
    RemType: null,
    RemTypeDesc: "",
    RemHost: null,
    RemHostDesc: "",
    CreatedBy: "",
    UpdatedBy: "",
    MyJobTJobHistory: "",
    MyJobWaitingOnCallBack: "",
    JobBalance: null,
    WorkFlowId: "",
    JobTypeName: "",
  };
}
